
import React from "react";
import { Link } from "react-router-dom";
import { Business } from "@/types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import BusinessImage from "@/components/common/BusinessImage";

interface BusinessTableProps {
  businesses: Business[];
}

const BusinessTableRow: React.FC<{ business: Business }> = ({ business }) => {
  return (
    <TableRow className="cursor-pointer hover:bg-muted/50">
      <TableCell className="font-medium">
        <Link to={`/business/${business.id}`} className="flex items-center">
          <div className="h-10 w-10 rounded-full overflow-hidden mr-3 bg-muted">
            <BusinessImage
              imageUrls={business.media_urls}
              fallbackUrl={business.image_url}
              placeholderSrc="/images/business-placeholder-thumb.svg"
              altText={business.name}
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <p className="font-medium">{business.name}</p>
            <p className="text-sm text-muted-foreground line-clamp-1">
              {business.description?.substring(0, 60)}
              {business.description && business.description.length > 60 ? "..." : ""}
            </p>
          </div>
        </Link>
      </TableCell>
      <TableCell>{business.category}</TableCell>
      <TableCell>
        {[business.city, business.county || business.state].filter(Boolean).join(", ")}
      </TableCell>
    </TableRow>
  );
};

const BusinessTable: React.FC<BusinessTableProps> = ({ businesses }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Business</TableHead>
            <TableHead>Category</TableHead>
            <TableHead>Location</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {businesses.map((business) => (
            <BusinessTableRow key={business.id} business={business} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default BusinessTable;
